import { EdhProtocolAttributePageState } from ".";
import { Option } from "../../util/option";

export const EdhProtocolAttributePageInitialState: EdhProtocolAttributePageState =
  {
    edhPrtclInfo: [],
    generalCode: {
      reviewingActionType: [],
      designCompletedActionType: [],
      inDefCommonFlagType: [],
    },
    isSaved: true,
    isEdited: false,
  };
